<h2 mat-dialog-title>
    Select the role or organisation you wish to load camera settings from
</h2>

<div mat-dialog-content style="overflow: hidden">
    <div class="container">
        <div class="col-12">
            <!--vertical align div using flexbox-->
            <!-- <h4 mat-dialog-title style="color:#5F6369;font-size:16px">Select the role or organisation you wish to load camera settings from</h4> -->

            <div class="row radio-options-wrapper">
                <div class="col-12">
                    <div class="col-8">
                        <mat-label>Load settings from</mat-label>

                        <mat-radio-group
                            [value]="updateType"
                            (change)="onTypeChange($event)"
                            aria-label="Select an option"
                        >
                            <mat-radio-button value="Organization">
                                Organisation
                            </mat-radio-button>

                            <mat-radio-button value="Role" *ngIf="isSiteAdmin">
                                Role
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                    <div class="col-4"></div>
                </div>
            </div>

            <div class="row">
                <div class="col-12">
                    <mat-form-field
                        class="mask"
                        appearance="fill"
                        *ngIf="updateType == 'Organization'"
                    >
                        <mat-label>Select organisation</mat-label>
                        <mat-select
                            [value]="selectedOrganizationId"
                            [disabled]="!isSiteAdmin"
                            (selectionChange)="onOrganizationChange($event)"
                        >
                            <mat-option
                                *ngFor="let o of this.organizations"
                                [value]="o.CompanyId"
                                >{{ o.Name }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field
                        class="mask"
                        appearance="fill"
                        *ngIf="updateType == 'Role'"
                    >
                        <mat-label>Select role</mat-label>
                        <mat-select
                            [value]="selectedRoleId"
                            (selectionChange)="onRoleChange($event)"
                        >
                            <mat-option
                                *ngFor="let o of this.roles"
                                [value]="o.ID"
                                >{{ o.RoleName }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>

            <div class="row mb-4">
                <div class="col-12">
                    <button
                        class="btn default-success rounded-pill"
                        style="width: 160px; height: 40px"
                        (click)="onSuccessClick()"
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>
